export default __webpack_public_path__ + "static/media/stl_upper_outline.0908042e.svg";